<!-- components/ImageViewer.vue -->
<template>
  <div class="image-viewer">
    <el-image
      v-if="src"
      :src="src"
      :preview-src-list="[src]"
      fit="cover"
      :style="style"
      :class="className"
      @click="handleClick"
    >
      <div slot="placeholder" class="image-placeholder">
        加载中...
      </div>
      <div slot="error" class="image-error">
        加载失败
      </div>
    </el-image>
    <div v-else class="image-empty">
      暂无图片
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    src: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: '60px',
    },
    height: {
      type: [String, Number],
      default: '60px',
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    style() {
      return {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
        height: typeof this.height === 'number' ? `${this.height}px` : this.height,
        cursor: 'pointer',
        borderRadius: '4px',
      };
    },
  },
  methods: {
    handleClick() {
      this.$emit('click', this.src);
    },
  },
};
</script>

<style scoped>
.image-viewer {
  display: inline-block;
}

.image-placeholder,
.image-error,
.image-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  border-radius: 4px;
  color: #909399;
  font-size: 12px;
}

.image-error {
  color: #f56c6c;
}

.image-empty {
  color: #c0c4cc;
}
</style>
